import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
export interface HowToUseCortexBlockProps {}

const HowToUseCortexBlock: React.SFC<HowToUseCortexBlockProps> = () => {
  const commercialCamera = require("../images/how-use/commercial-camera.svg") as string
  const jetsonNano = require("../images/how-use/jetson-nano.svg") as string
  const json = require("../images/how-use/json.jpg") as string
  const [howUse, setHowUse] = useState([
    {
      icon: commercialCamera,
      title: "Jetson Nano™を推奨",
      description:
        "小型で低コスト、かつ低消費電力のAIデバイス開発を可能にするシステムオンモジュールであるJetson Nano™モジュールを利用することを想定しております。スマートシティからロボット工学まで様々な業界でのAI導入を想定してVisualCortexは開発されています。 参考：",
      link: "Jetson Nano™ 公式ウェブサイト",
      animation: "slide-right",
      url:
        "https://www.nvidia.com/en-us/autonomous-machines/embedded-systems/jetson-nano/",
    },
    {
      icon: jetsonNano,
      title: "市販のカメラ",
      description:
        "市販されている一般的なウェブカメラでも対応できるようにVisualCortexは設計されています。専用の特別なカメラを購入する必要はありません。",
      link: "",
      animation: "slide-up",
      url: "",
    },
    {
      icon: json,
      title: "JSON",
      description:
        "認識結果はJSON(JavaScript Object Notation)で取得可能です。軽量なテキストベースのデータ交換用フォーマットであり、様々な外部システムへのデータ連携が可能です。クーガーが開発する人型AI“ルーデンス”にも使用されています。",
      link: "JSON 公式ウェブサイト",
      animation: "slide-left",
      url: "https://www.json.org/json-en.html",
    },
  ])
  return (
    <div className="container-full block-how-use">
      <h3 className="u-text-center subtitle-section">使い方</h3>
      <p className="block-how-use__text u-text-center">
        スピード感を重要視したスタンドアローン型、シンプルで安価なシステムですぐに稼働可能です。
      </p>
      <div className="container">
        <div className="row">
          {howUse.map((item, i) => (
            <div className="col-lg-4 u-margin-tb-1" key={i} >
              <div className="block-how-use__card">
                <img className="image-card" src={item.icon} alt={item.title} />

                <h4 className="u-text-center">{item.title}</h4>
                <p className="u-text-center">
                  {item.description}
                  {item.url === "" ? (
                    <span>{item.link}</span>
                  ) : (
                    <a href={item.url} target="_blank" rel="noreferrer">
                      {item.link}
                    </a>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HowToUseCortexBlock
